// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"da901a17","453":"df77193d","585":"7a7811ca","693":"7c7fe99d","723":"60e4ec37","920":"8dcfc8c3","966":"44a3047c","969":"c854ea1e"}[chunkId] + ".chunk.js";
};